import styled, { useTheme } from 'styled-components';
import Modal, { FullHeightModalContent } from '../../../components/Modal';
import { ParagraphLargeText } from '../../../components/Texts';
import Steps from '../../../components/Steps';
import {
  useGiftForm,
  GiftFormProvider,
} from '../../../components/GiftFormContext';
import { useEffect } from 'react';

const TitleAndStepsContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

const GiftFlowModalContent = ({
  onClose,
  initialStep = 0,
  tokenAddress,
  network,
}) => {
  const theme = useTheme();
  const {
    initializeForm,
    targetTokenAddress,
    network: formNetwork,
    setValue,
  } = useGiftForm();

  // Initialize form with token if provided via props (but not already set)
  useEffect(() => {
    if (
      tokenAddress &&
      network &&
      (targetTokenAddress !== tokenAddress ||
        (formNetwork && formNetwork !== network))
    ) {
      console.log('initializing form', tokenAddress, network);
      initializeForm({
        initialValues: {
          targetTokenAddress: tokenAddress,
          network: network,
        },
      });
    }
  }, [tokenAddress, network, initializeForm, targetTokenAddress, formNetwork]);

  const {
    currentStep,
    totalSteps,
    currentTitle,
    Component,
    onNextStepName,
    onBackStepName,
    shouldShowBackButton,
    buttonLabel,
    updateStepInUrl,
  } = useGiftForm();

  const handleClose = () => {
    // Reset form when modal actually closes
    initializeForm({ initialValues: {} });
    onClose();
  };

  const handleBack = () => {
    if (onBackStepName) {
      updateStepInUrl(onBackStepName);
    } else {
      handleClose();
    }
  };

  return (
    <Modal
      onClose={handleClose}
      onBack={shouldShowBackButton ? handleBack : undefined}
    >
      <FullHeightModalContent>
        <TitleAndStepsContainer>
          <ParagraphLargeText
            style={{ textAlign: 'center', color: theme.text.title }}
          >
            {currentTitle}
          </ParagraphLargeText>
          <Steps steps={totalSteps} currentStep={currentStep} />
        </TitleAndStepsContainer>
        <Component
          isModal={true}
          currentStep={currentStep}
          onContinue={() => {
            if (onNextStepName) {
              updateStepInUrl(onNextStepName);
            }
          }}
          buttonLabel={buttonLabel}
        />
      </FullHeightModalContent>
    </Modal>
  );
};

const GiftFlowModal = ({ onClose, initialStep = 0, tokenAddress, network }) => {
  return (
    <GiftFormProvider>
      <GiftFlowModalContent
        onClose={onClose}
        initialStep={initialStep}
        tokenAddress={tokenAddress}
        network={network}
      />
    </GiftFormProvider>
  );
};

export default GiftFlowModal;
